import MadeHandLeaf from '@/services/five-card-hands/five-card-hand-leaf/MadeHandLeaf';
import MadeHandParent from '@/services/five-card-hands/five-card-hand-parent/MadeHandParent';
import FiveCardHandsCategory from '@/services/five-card-hands/categories/FiveCardHandsCategory';

export default class MadeHands extends FiveCardHandsCategory {
  constructor () {
    super();
    this.data = [
      new MadeHandParent({
        id: 'fourOfAKindPlus',
        text: 'Four of a kind+',
        fullText: 'Four of a kind+',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'fourOfAKindPlus';
        },
        children: [
          new MadeHandLeaf({
            id: 'fourOfAKindPlus:royalFlush',
            text: 'Royal flush',
            fullText: 'Royal flush',
            inlineText: 'a royal flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'fourOfAKindPlus:royalFlush';
            },
          }),
          new MadeHandLeaf({
            id: 'fourOfAKindPlus:straightFlush',
            text: 'Straight flush',
            fullText: 'Straight flush',
            inlineText: 'a straight flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'fourOfAKindPlus:straightFlush';
            },
          }),
          new MadeHandLeaf({
            id: 'fourOfAKindPlus:fourOfAKind',
            text: 'Four of a kind',
            fullText: 'Four of a kind',
            inlineText: 'four of a kind',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'fourOfAKindPlus:fourOfAKind';
            },
          }),
        ]
      }),
      new MadeHandLeaf({
        id: 'fullHouse',
        text: 'Full house',
        fullText: 'Full house',
        inlineText: 'a full house',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id === 'fullHouse';
        },
      }),
      new MadeHandParent({
        id: 'flush',
        text: 'Flush',
        fullText: 'Flush',
        inlineText: 'a flush',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'flush';
        },
        children: [
          new MadeHandLeaf({
            id: 'flush:nut',
            text: 'Nut',
            fullText: 'Nut flush',
            inlineText: 'a nut flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'flush:nut';
            },
          }),
          new MadeHandLeaf({
            id: 'flush:secondNut',
            text: 'Second nut',
            fullText: 'Second nut flush',
            inlineText: 'a second nut flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'flush:secondNut';
            },
          }),
          new MadeHandLeaf({
            id: 'flush:thirdNut',
            text: 'Third nut',
            fullText: 'Third nut flush',
            inlineText: 'a third nut flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'flush:thirdNut';
            },
          }),
          new MadeHandLeaf({
            id: 'flush:weak',
            text: 'Weak',
            fullText: 'Weak flush',
            inlineText: 'a weak flush',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'flush:weak';
            },
          }),
        ],
      }),
      new MadeHandLeaf({
        id: 'straight',
        text: 'Straight',
        fullText: 'Straight',
        inlineText: 'a straight',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id === 'straight';
        },
      }),
      new MadeHandParent({
        id: 'threeOfAKind',
        text: 'Three of a kind',
        fullText: 'Three of a kind',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'threeOfAKind';
        },
        children: [
          new MadeHandLeaf({
            id: 'threeOfAKind:topSet',
            text: 'Top set',
            fullText: 'Top set',
            inlineText: 'top set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:topSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:secondSet',
            text: 'Second set',
            fullText: 'Second set',
            inlineText: 'second set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:secondSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:thirdSet',
            text: 'Third set',
            fullText: 'Third set',
            inlineText: 'third set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:thirdSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:fourthSet',
            text: 'Fourth set',
            fullText: 'Fourth set',
            inlineText: 'fourth set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:fourthSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:middleSet',
            text: 'Middle set',
            fullText: 'Middle set',
            inlineText: 'middle set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:middleSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:bottomSet',
            text: 'Bottom set',
            fullText: 'Bottom set',
            inlineText: 'bottom set',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:bottomSet';
            },
          }),
          new MadeHandLeaf({
            id: 'threeOfAKind:trips',
            text: 'Trips',
            fullText: 'Trips',
            inlineText: 'trips',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'threeOfAKind:trips';
            },
          }),
        ],
      }),
      new MadeHandParent({
        id: 'twoPair',
        text: 'Two pair',
        fullText: 'Two pair',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'twoPair';
        },
        children: [
          new MadeHandLeaf({
            id: 'twoPair:usingTopBoardCard',
            text: '<abbr title="Using top board card">Strong</abbr>',
            fullText: 'Two pair using top board card',
            inlineText: 'two pair using the top board card',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'twoPair:usingTopBoardCard';
            },
          }),
          new MadeHandLeaf({
            id: 'twoPair:weak',
            text: 'Weak',
            fullText: 'Weak two pair',
            inlineText: 'a weak two pair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'twoPair:weak';
            },
          }),
        ],
      }),
      new MadeHandParent({
        id: 'pair',
        text: 'Pair',
        fullText: 'Pair',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'pair';
        },
        children: [
          new MadeHandLeaf({
            id: 'pair:overpair',
            text: 'Overpair',
            fullText: 'Overpair',
            inlineText: 'an overpair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:overpair';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:tptk',
            text: '<abbr title="Top pair top kicker">TPTK</abbr>',
            fullText: 'TPTK',
            inlineText: 'TPTK',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:tptk';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:tpgk',
            text: '<abbr title="Top pair good kicker">TPGK</abbr>',
            fullText: 'TPGK',
            inlineText: 'TPGK',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:tpgk';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:tpwk',
            text: '<abbr title="Top pair weak kicker">TPWK</abbr>',
            fullText: 'TPWK',
            inlineText: 'TPWK',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:tpwk';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:ppUnderTp',
            text: '<abbr title="Pocket pair under top pair">PP under TP</abbr>',
            fullText: 'PP under TP',
            inlineText: 'a pocket pair under top pair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:ppUnderTp';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:secondPair',
            text: 'Second pair',
            fullText: 'Second pair',
            inlineText: 'second pair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:secondPair';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:middlePair',
            text: 'Middle pair',
            fullText: 'Middle pair',
            inlineText: 'middle pair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:middlePair';
            },
          }),
          new MadeHandLeaf({
            id: 'pair:weakPair',
            text: 'Weak',
            fullText: 'Weak pair',
            inlineText: 'a weak pair',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'pair:weakPair';
            },
          }),
        ],
      }),
      new MadeHandParent({
        id: 'usingABoardCard',
        text: 'Using a board card',
        fullText: 'Using a board card',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'usingABoardCard';
        },
        children: [
          new MadeHandParent({
            id: 'usingABoardCard:flushUsingOneHoleCard',
            text: 'Flush using one hole card',
            fullText: 'Flush using one hole card',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id.split(':')[0] === 'usingABoardCard' && handInfo.id.split(':')[1] === 'flushUsingOneHoleCard';
            },
            children: [
              new MadeHandLeaf({
                id: 'usingABoardCard:flushUsingOneHoleCard:nut',
                text: 'Nut',
                fullText: 'Nut flush using one hole card',
                isAHit: function (handInfo, drawInfo) {
                  return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:nut';
                },
              }),
              new MadeHandLeaf({
                id: 'usingABoardCard:flushUsingOneHoleCard:secondNut',
                text: 'Second nut',
                fullText: 'Second nut flush using one hole card',
                isAHit: function (handInfo, drawInfo) {
                  return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:secondNut';
                },
              }),
              new MadeHandLeaf({
                id: 'usingABoardCard:flushUsingOneHoleCard:thirdNut',
                text: 'Third nut',
                fullText: 'Third nut flush using one hole card',
                isAHit: function (handInfo, drawInfo) {
                  return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:thirdNut';
                },
              }),
              new MadeHandLeaf({
                id: 'usingABoardCard:flushUsingOneHoleCard:weak',
                text: 'Weak',
                fullText: 'Weak flush using one hole card',
                isAHit: function (handInfo, drawInfo) {
                  return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:weak';
                },
              })
            ],
          }),
          new MadeHandLeaf({
            id: 'usingABoardCard:flushOnBoard',
            text: 'Flush on board',
            fullText: 'Flush on board',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'usingABoardCard:flushOnBoard';
            },
          }),
          new MadeHandLeaf({
            id: 'usingABoardCard:threeOfAKindOnBoard',
            text: 'Three of a kind on board',
            fullText: 'Three of a kind on board',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'usingABoardCard:threeOfAKindOnBoard';
            },
          }),
          new MadeHandLeaf({
            id: 'usingABoardCard:twoPairWithPairOnBoard',
            text: 'Two pair w/ pair on board',
            fullText: 'Two pair w/ pair on board',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'usingABoardCard:twoPairWithPairOnBoard';
            },
          }),
          new MadeHandLeaf({
            id: 'usingABoardCard:twoPairOnBoard',
            text: 'Two pair on board',
            fullText: 'Two pair on board',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'usingABoardCard:twoPairOnBoard';
            },
          }),
          new MadeHandLeaf({
            id: 'usingABoardCard:pairOnBoard',
            text: 'Pair on board',
            fullText: 'Pair on board',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'usingABoardCard:pairOnBoard';
            },
          })
        ],
      }),
      new MadeHandParent({
        id: 'highCard',
        text: 'High card',
        fullText: 'High card',
        isAHit: function (handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'highCard';
        },
        children: [
          new MadeHandLeaf({
            id: 'highCard:aceHigh',
            text: 'Ace high',
            fullText: 'Ace high',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'highCard:aceHigh';
            },
          }),
          new MadeHandLeaf({
            id: 'highCard:kingHigh',
            text: 'King high',
            fullText: 'King high',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'highCard:kingHigh';
            },
          }),
          new MadeHandLeaf({
            id: 'highCard:weak',
            text: 'Weak',
            fullText: 'Weak high card',
            isAHit: function (handInfo, drawInfo) {
              return handInfo.id === 'highCard:weak';
            },
          }),
        ],
      }),
    ];
    super.setBreadcrumbText();
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/categories/MadeHands.js